module.exports = __webpack_public_path__ + "img/wuli.c79c08e4.png";